/**
 * 常量定义
 */
export default {
}
